import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PLDialogConfig } from '@common/components/pl-dialog';

let nextUniqueId = 0;

@Component({
  selector: 'pl-dialog',
  templateUrl: './pl-dialog.component.html',
  styleUrls: ['./pl-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PLDialogComponent implements AfterViewInit {
  @ViewChild('primaryButton', { read: ElementRef })
  primaryButton?: ElementRef<HTMLButtonElement>;

  readonly titleId = `pl-dialog-title-${nextUniqueId}`;

  readonly contentId = `pl-dialog-content-${nextUniqueId}`;

  constructor(
    public dialogRef: MatDialogRef<PLDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public config: PLDialogConfig
  ) {
    nextUniqueId += 1;
  }

  ngAfterViewInit(): void {
    this.primaryButton?.nativeElement.focus();
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onButtonClick(): void {
    this.dialogRef.close();
  }
}
